/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsuranceFormDataModel } from '../../models/insurance-form-data-model';

export interface InsuranceIdGet$Params {
  id: string;
}

export function insuranceIdGet(http: HttpClient, rootUrl: string, params: InsuranceIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<InsuranceFormDataModel>> {
  const rb = new RequestBuilder(rootUrl, insuranceIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<InsuranceFormDataModel>;
    })
  );
}

insuranceIdGet.PATH = '/Insurance/{id}';
